import { render, staticRenderFns } from "./TopProductsList.vue?vue&type=template&id=45d6c55e&"
import script from "./TopProductsList.vue?vue&type=script&lang=js&"
export * from "./TopProductsList.vue?vue&type=script&lang=js&"
import style0 from "./TopProductsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports